import React from 'react';
import Buttons from './Buttons';
import './ButtonGroup.scss';
import { Grid } from '@mui/material';

const ButtonGroup = ({label, onClick, values, options, style, perRows }) => {

    return (
        <div className='button-group' style={style}>
            {
                (typeof label !== 'undefined' && label !== '') ?
                <p className='label'>{label}</p>
                :
                null
            }
            <Grid container direction={'row'} alignItems="center" columns={16}>
            {
                options.map((data,i) => {
                    return (
                        <Grid key={i} style={{ marginRight : (i+1)%perRows === 0 ? 0 : 15, marginBottom : 8 }}>
                            <Buttons key={i} title={data.label} value={data.value} onClick={() => onClick(data.value)} selected={values.indexOf(data.value) !== -1}/>
                        </Grid>
                    )
                })
            }
            </Grid>
        </div>
    )
}

export default ButtonGroup;